import React, { useEffect, useState } from 'react'
import CloseIcon from '../../../../../../../../../public/assets/icon/search-close.svg'
import AllProduct from 'src/components/ProductPage/AllProduct'
import ProductListView from 'src/components/ProductPage/TabProduct/ProductListView'
import { useRouter } from 'next/router'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useAppDispatch } from 'src/store/store'
import { useSelector } from 'react-redux'
import Link from 'next/link'

export default function MobileViewSubCategory({ fetchUpdatedProduct, setPage, page, dataLimite, category, subCategory, childSubCategory }) {
  const router = useRouter()
  // const [page, setPage] = useState(1)
  // const [dataLimite, setDataLimite] = useState(40)
  const dispatch = useAppDispatch()
  const categoryData = useSelector((state: any) => state?.fetchCategory?.categoryData)

  const productByCategory = useSelector((state: any) => state?.productByCategory)
  const [filterData, setFilterData] = useState<any>({ subCategory: [], category: [] })

  const [lastScrollTop, setLastScrollTop] = useState(0)
  const [scrollDirection, setScrollDirection] = useState('noScroll')

  // useEffect(() => {
  //   setPage(1)
  //   // dispatch(
  //   //   fetchProductByCategory({
  //   //     category: 'Fashion & Accessories',
  //   //     subCategory: router?.asPath?.includes('women') ? 'Women' : 'Men',
  //   //     childSubCategory: router?.query?.category ? router?.query?.category : '',
  //   //     isShopifyProduct: false,
  //   //     page: page,
  //   //     limit: dataLimite,
  //   //   }),
  //   // )
  // }, [])

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollTop === 0) {
        setScrollDirection('noScroll')
      } else if (currentScrollTop > lastScrollTop) {
        setScrollDirection('topToDownsc')
      } else {
        setScrollDirection('downToTopsc')
      }
      setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [lastScrollTop])

  const manageApplianceCategoryModal = useSelector((state: any) => state?.manageApplianceCategoryModal?.data)

  const [MenMobileviewSidebar, setMenMobileviewSidebar] = useState(false)
  const [view, setView] = useState('grid')
  const [SerchDetails, setSerchDetails] = useState(false)

  return (
    <div>
      <div className="men-mobileSubCategory-back-alignment">
        <div
          className="back_details-alignment"
          onClick={() => {
            router.push('/fashion/men/', undefined, { scroll: false })
            dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
          }}
        >
          <div>
            <img src="/assets/icon/left-icon.svg" alt="back-page" />
          </div>
          <p>Men Fa...</p>
        </div>
        <div className="mobile-heading-alignment">
          <h4>Shop by Cate...</h4>
        </div>
      </div>
      <div className="men-mobile-view-details-fashion-name-search-alignment">
        <div className="mobile-women-width-alignment">
          {/* MobileView Sidebar Alignment */}
          <div className="mobile-view-sidebar-alignment">
            <div className="mobile-search-sidebar-details-box-alignment">
              {MenMobileviewSidebar && (
                <div className="men-mobile-view-sidebar-box-alignment">
                  <div className="men-catrgory-mobile-silder-side-main-details">
                    {categoryData?.map((category, index) => {
                      return (
                        <React.Fragment key={index}>
                          <Link
                            href={{
                              pathname: `/fashion/men/${category?.slug}`,
                              // query: { category: category.name },
                            }}
                            scroll={false}
                          >
                            <div
                              className={`men-mobile-slider-all-details-alignment ${router?.query?.id === category?.slug && 'active-men-sidebar'
                                }`}
                            // onClick={() => setCategoryName(category.name)}
                            >
                              <div className="mobile-slider-details-img">
                                <div className="mobile-slider-child-details-img">
                                  <img src={category?.media} alt="Frame1" />
                                </div>
                              </div>
                              <p>{category?.name}</p>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    })}
                  </div>
                </div>
              )}
              {/* <div
                className={`${'mobile-view-left-arrow-alignment'} ${MenMobileviewSidebar ? 'd-flex' : 'd-none'}`}
                onClick={() => {
                  setMenMobileviewSidebar(false)
                  setSerchDetails(false)
                }}
              >
                <img src="/assets/icon/left-icon.svg" className="static" alt="back-page" />
              </div> */}
            </div>
            {/* MobileView Child-heading */}
            <div className="header-width-alignment">
              <div className="right-side-alignment">
                <div
                  className={`
                    headerDesign
                    ${scrollDirection === 'topToDownsc' ? 'topToDownsc' : scrollDirection === 'downToTopsc' ? 'downToTopsc' : ''
                    }
                  `}
                  style={{ padding: '0' }}
                >
                  <div
                    className={
                      MenMobileviewSidebar
                        ? 'mobile-view-child-heading-alignment open-sidebar-header-change'
                        : 'mobile-view-child-heading-alignment'
                    }
                  >
                    <div className="mobile-view-left-side-flex-alignment">
                      <div
                        className={`${'mobile-view-close-arrow-alignment'} ${MenMobileviewSidebar ? 'd-none' : 'd-block'
                          }`}
                        onClick={() => {
                          setMenMobileviewSidebar(!MenMobileviewSidebar)
                          setSerchDetails(false)
                        }}
                      >
                        <img src="/assets/icon/left-icon.svg" className="rotate" alt="back-page" />
                      </div>
                      <div className="mobile-view-child-name-alignment">
                        <h5>{manageApplianceCategoryModal?.id?.name}</h5>
                        <span>({productByCategory?.product?.getAllProducts?.data?.length || 0} item)</span>
                      </div>
                    </div>
                    <div className="mobile-view-list-alignment">
                      <div
                        className="mobile-search-icon-alignment"
                        onClick={() => {
                          setSerchDetails(!SerchDetails)
                          setMenMobileviewSidebar(!MenMobileviewSidebar)
                        }}
                      >
                        <img src="/assets/icon/Search-grey-icon.svg" />
                      </div>
                      {!MenMobileviewSidebar && (
                        <div className="mobile-view-list-alignment">
                          <div onClick={() => setView('grid')}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="3"
                                y="3"
                                width="7.33333"
                                height="6"
                                rx="1.66667"
                                stroke={view === 'grid' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="13.6719"
                                y="3"
                                width="7.33333"
                                height="8.66667"
                                rx="1.66667"
                                stroke={view === 'grid' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="3"
                                y="12.3281"
                                width="7.33333"
                                height="8.66667"
                                rx="1.66667"
                                stroke={view === 'grid' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="13.6719"
                                y="15"
                                width="7.33333"
                                height="6"
                                rx="1.66667"
                                stroke={view === 'grid' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                            </svg>
                          </div>
                          <div onClick={() => setView('list')}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="3"
                                y="3"
                                width="4"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="11"
                                y="3"
                                width="10"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="3"
                                y="10"
                                width="4"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="3"
                                y="17"
                                width="4"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="11"
                                y="10"
                                width="10"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="11"
                                y="17"
                                width="10"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                            </svg>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div
                  className={`
                    headerDesign
                    ${scrollDirection === 'topToDown' ? 'topToDown' : scrollDirection === 'downToTop' ? 'downToTop' : ''
                    }
                  `}
                  style={{ padding: '0' }}
                >
                  <div
                    className={
                      MenMobileviewSidebar
                        ? 'mobile-view-child-heading-alignment open-sidebar-header-change'
                        : 'mobile-view-child-heading-alignment'
                    }
                  >
                    <div className="mobile-view-left-side-flex-alignment">
                      <div
                        className={`${'mobile-view-close-arrow-alignment'} ${MenMobileviewSidebar ? 'd-none' : 'd-block'
                          }`}
                        onClick={() => {
                          setMenMobileviewSidebar(!MenMobileviewSidebar)
                          setSerchDetails(false)
                        }}
                      >
                        <img src="/assets/icon/left-icon.svg" className="rotate" alt="back-page" />
                      </div>
                      <div className="mobile-view-child-name-alignment">
                        <h5>{manageApplianceCategoryModal?.id?.name}</h5>
                        <span>({productByCategory?.product?.getAllProducts?.data?.length || 0} item)</span>
                      </div>
                    </div>
                    <div className="mobile-view-list-alignment">
                      <div
                        className="mobile-search-icon-alignment"
                        onClick={() => {
                          setSerchDetails(!SerchDetails)
                          setMenMobileviewSidebar(!MenMobileviewSidebar)
                        }}
                      >
                        <img src="/assets/icon/Search-grey-icon.svg" />
                      </div>
                      {!MenMobileviewSidebar && (
                        <div className="mobile-view-list-alignment">
                          <div onClick={() => setView('grid')}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="3"
                                y="3"
                                width="7.33333"
                                height="6"
                                rx="1.66667"
                                stroke={view === 'grid' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="13.6719"
                                y="3"
                                width="7.33333"
                                height="8.66667"
                                rx="1.66667"
                                stroke={view === 'grid' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="3"
                                y="12.3281"
                                width="7.33333"
                                height="8.66667"
                                rx="1.66667"
                                stroke={view === 'grid' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="13.6719"
                                y="15"
                                width="7.33333"
                                height="6"
                                rx="1.66667"
                                stroke={view === 'grid' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                            </svg>
                          </div>
                          <div onClick={() => setView('list')}>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="3"
                                y="3"
                                width="4"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="11"
                                y="3"
                                width="10"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="3"
                                y="10"
                                width="4"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="3"
                                y="17"
                                width="4"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="11"
                                y="10"
                                width="10"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                              <rect
                                x="11"
                                y="17"
                                width="10"
                                height="4"
                                rx="1.66667"
                                stroke={view === 'list' ? '#A855F7' : '#ACB1C0'}
                                strokeWidth="2"
                              />
                            </svg>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}
                {SerchDetails && (
                  <div className="mobile-child-search-alignment">
                    <input type="text" />
                    <div className="close-alignment">
                      <img src={CloseIcon.src} alt="CloseIcon" />
                    </div>
                  </div>
                )}
                <div className="">
                  <div
                    className={
                      view === 'grid'
                        ? 'women-mobile-findYourStyle_product_block men-mobile-contain'
                        : 'women-mobile-findYourStyle_product_block'
                    }
                  >
                    <div className="">
                      {view === 'grid' && (
                        <AllProduct
                          products={productByCategory?.product?.getAllProducts?.data}
                          storeId={0}
                          color={'#1E2432'}
                          isPadding={true}
                          isFilterMenu={true}
                          total={productByCategory?.product?.getAllProducts?.total}
                          dataLimite={dataLimite}
                          setPage={setPage}
                          page={page}
                          topForFilter={66}
                          isMobile={true}
                          mobileTopForFilter={0}
                          isForMen={true}
                          isCalled={productByCategory?.called}
                          setFilterData={setFilterData}
                          filterData={filterData}
                          APIcall={fetchUpdatedProduct}
                          category_slug={category}
                          subCategory_slug={subCategory}
                          childSubCategory_slug={childSubCategory}
                        />
                      )}
                    </div>
                    {view === 'list' && (
                      <ProductListView
                        products={productByCategory?.product?.getAllProducts?.data}
                        color={'#1E2432'}
                        stateForWidth={MenMobileviewSidebar}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
